export default "__VITE_ASSET__5af179f0__"